export const GET_EDUCATION_REQUEST = 'GET_EDUCATION_REQUEST';
export const GET_EDUCATION_SUCCESS = 'GET_EDUCATION_SUCCESS';
export const GET_EDUCATION_FAILURE = 'GET_EDUCATION_FAILURE';

export const CREATE_EDUCATION_REQUEST = 'CREATE_EDUCATION_REQUEST';
export const CREATE_EDUCATION_SUCCESS = 'CREATE_EDUCATION_SUCCESS';
export const CREATE_EDUCATION_FAILURE = 'CREATE_EDUCATION_FAILURE';

export const DELETE_EDUCATION_REQUEST = 'DELETE_EDUCATION_REQUEST';
export const DELETE_EDUCATION_SUCCESS = 'DELETE_EDUCATION_SUCCESS';
export const DELETE_EDUCATION_FAILURE = 'DELETE_EDUCATION_FAILURE';

export const UPDATE_EDUCATION_REQUEST = 'UPDATE_EDUCATION_REQUEST';
export const UPDATE_EDUCATION_SUCCESS = 'UPDATE_EDUCATION_SUCCESS';
export const UPDATE_EDUCATION_FAILURE = 'UPDATE_EDUCATION_FAILURE';

export const ADD_NEW_EDUCATION_SUCCESS = 'ADD_NEW_EDUCATION_SUCCESS';
export const DELETE_NEW_EDUCATION_SUCCESS = 'DELETE_NEW_EDUCATION_SUCCESS';
export const CHANGE_WORK_EDUCATION_SUCCESS = 'CHANGE_WORK_EDUCATION_SUCCESS';
export const RESET_EDUCATIONS_LIST_SUCCESS = 'RESET_EDUCATIONS_LIST_SUCCESS';
